import React from 'react';

import { Container } from './styles';

const AuthLayout: React.FC = ({ children }) => (
  <Container>{children}</Container>
);

export default AuthLayout;
